<script setup lang="ts">
import { WidgetRatesAction } from '~/components/widget/rates'
import { SUPPORTED_CURRENCIES } from '~/data/pages/rates/consts'
const route = useRoute()

const currencyParam = computed(() => {
  const param = route.params.currency
  return Array.isArray(param) ? param[0]?.toUpperCase() : param?.toUpperCase()
})

if (!SUPPORTED_CURRENCIES.includes(currencyParam.value)) {
  showError({ statusCode: 404 })
}
</script>

<template>
  <WidgetRatesAction />
</template>
